/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { ActivatedRoute, Router } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable()
export class NavigationService {
    /**
     * Store the appliance ID.
     * @private
     */
    private applianceId: string;

    /**
     * Store url history.
     * @private
     */
    private _history: string[] = [];

    /**
     * Store redirection url.
     * @private
     */
    private _redirectLocation: string;

    constructor(
        private route: ActivatedRoute,
        private router: Router
    ) {
    }

    /**
     * Get url history.
     */
    get history(): any {
        return this._history;
    }

    /**
     * Add to url history.
     * @param url
     */
    set history(url: any) {
        if (!this._history.includes(url)) {
            this._history.push(url);
        }
        if (this._history.length > 2) {
            this._history.shift();
        }
    }

    /**
     * Set the redirectLocation.
     * @param url
     */
    set redirectLocation(url: string) {
        this._redirectLocation = url;
    }

    /**
     * Get stored the redirectLocation.
     */
    get redirectLocation(): string {
        return this._redirectLocation;
    }

    /**
     * Get the url path.
     * @param urlPath
     */
    public getEnduranceUrl(urlPath: string): string {
        if (!this.applianceId) {
            this.applianceId = this.getApplianceId();
        }

        return `/lb/${this.applianceId}${urlPath}`;
    }

    /**
     * Clean the endurance url (removes lb and the appliance id).
     * @param url
     */
    public cleanEnduranceUrl(url: string): string {
        if (!this.applianceId) {
            this.applianceId = this.getApplianceId();
        }

        return url.replace('/lb/' + this.applianceId, '');
    }

    /**
     * Get the appliance ID from local storage.
     */
    public getApplianceId(): string {
        const lbUser = JSON.parse(localStorage.getItem('lbUser'));

        return lbUser.applianceId;
    }

    /**
     * Remove params from the URL.
     */
    public removeParamsFromUrl(): void {
        this.router.navigate([], { replaceUrl: true, relativeTo: this.route }).then(() => {
        }).catch();
    }
}
